/**
 * Frontend Release History
 *
 * This file tracks all frontend releases with their start dates and descriptions.
 * The active release is automatically exported as FRONTEND_RELEASE.
 */

export const RELEASES = [
  {
    version: 'int-v4.3.0',
    startDate: '2025-12-01',
    description: 'Add post-exam application support'
  },
  {
    version: 'int-v4.3.0-rc.1+02',
    startDate: '2025-11-28',
    description: 'Fix enabled final save button without grade input on Proponent UI. Update UI text.'
  },
  {
    version: 'int-v4.3.0-rc.1+01',
    startDate: '2025-11-28',
    description: 'Show release button on President to Print decision UI'
  },
  {
    version: 'int-v4.3.0-rc.1',
    startDate: '2025-11-27',
    description: 'Add President finalization post-exam application support'
  },
  {
    version: 'int-v4.3.0-dev.6',
    startDate: '2025-11-25',
    description: 'Add Print Decision post-exam application support'
  },
  {
    version: 'int-v4.3.0-dev.5',
    startDate: '2025-11-25',
    description: 'Add President (to Print Decision) post-exam application support'
  },
  {
    version: 'int-v4.3.0-dev.4',
    startDate: '2025-11-19',
    description: 'Add Process Viewer post-exam application support'
  },
  {
    version: 'int-v4.3.0-dev.3',
    startDate: '2025-11-19',
    description: 'Add Special proponent post-exam application support'
  },
  {
    version: 'int-v4.3.0-dev.2+05',
    startDate: '2025-11-18',
    description: 'Fix disable post-exam application on Prechecker'
  },
  {
    version: 'int-v4.3.0-dev.2+04',
    startDate: '2025-11-13',
    description: 'Add post-exam application history support'
  },
  {
    version: 'int-v4.3.0-dev.2+03',
    startDate: '2025-11-07',
    description: 'Add post-exam application support to Prechecker judgment form'
  },
  {
    version: 'int-v4.3.0-dev.2+02',
    startDate: '2025-11-03',
    description: 'Add University Exams menu item on Prechecker role and adapt assign/release dialog'
  },
  {
    version: 'int-v4.3.0-dev.2+01',
    startDate: '2025-10-23',
    description: 'Add create post-exam application button and 7100 app type on filters'
  },
  // {
  //   version: 'int-v4.3.0-dev.2',
  //   startDate: '2025-10-23',
  //   description: 'Add Prechecker post-exam application support'
  // },
  {
    version: 'int-v4.3.0-dev.1',
    startDate: '2025-10-22',
    description: 'Add compensatory measures search field and decision column on Application Search form'
  },
  {
    version: 'int-v4.2.8',
    startDate: '2025-10-16',
    description: 'Add accessibility widget'
  },
  {
    version: 'int-v4.2.7',
    startDate: '2025-10-06',
    description: 'Add comments on Academic Director judgement (reappraisals) and fix double Prechecker comments'
  },
  {
    version: 'int-v4.2.6',
    startDate: '2025-09-17',
    description: 'Combined release for #66, #65 and #46 (partial) issues'
  },
  {
    version: 'int-v4.2.6-rc.1',
    startDate: '2025-09-16',
    description: 'Display full format birthdate field on Application search form (Issue #46 - partial)'
  },
  {
    version: 'int-v4.2.5-rc.1',
    startDate: '2025-09-12',
    description: 'Allow reappraisal release from President to Prechecker (Issue #65)'
  },
  {
    version: 'int-v4.2.4-rc.1',
    startDate: '2025-09-05',
    description: 'Application return to President from Reappraisal board (Issue #66)'
  },
  {
    version: 'int-v4.2.3',
    startDate: '2025-09-05',
    description: 'Fix Council Members missing on President\'s Special Reappraisal Board member selection list (Issue #70)'
  },
  {
    version: 'int-v4.2.2',
    startDate: '2025-07-24',
    description: 'Enhance application search form and fix display issues'
  },
  {
    version: 'int-v4.2.1',
    startDate: '2025-07-16',
    description: 'Fix missing consultants list'
  },
  {
    version: 'int-v4.2.0',
    startDate: '2025-07-04',
    description: 'Add reappraisal applications support'
  },
  {
    version: 'int-v4.2.0-rc.2',
    startDate: '2025-07-01',
    description: 'After first test changes'
  },
  {
    version: 'int-v4.2.0-rc.1',
    startDate: '2025-06-17',
    description: 'Update President decision\'s feature for reappraisals'
  },
  {
    version: 'int-v4.2.0-dev.5',
    startDate: '2025-06-09',
    description: 'Before reappraisal president\'s decision implementation'
  },
  {
    version: 'int-v4.2.0-dev.4',
    startDate: '2025-05-13',
    description: 'Update Proponent\'s and Academic Director\'s UI and history for reappraisals. Minor fixes'
  },
  {
    version: 'int-v4.2.0-dev.3',
    startDate: '2025-05-03',
    description: 'Update Reappraisal Board member\'s UI'
  },
  {
    version: 'int-v4.2.0-dev.2',
    startDate: '2025-04-28',
    description: 'Improve President\'s UI on reappraisals. First update Board Member\'s UI'
  },
  {
    version: 'int-v4.2.0-dev.1',
    startDate: '2024',
    description: 'Reappraisals 2024'
  }
]

// Export the current/active release (first in array)
export const FRONTEND_RELEASE = RELEASES[0].version

// Helper function to get release info
export function getReleaseInfo (version) {
  return RELEASES.find(release => release.version === version)
}

// Helper function to get formatted release string for logging
export function getFormattedRelease (version) {
  const release = getReleaseInfo(version)
  if (!release) return version
  return `${release.version} (Started ${release.startDate})`
}



// WEBPACK FOOTER //
// ./src/releases.js